import React from 'react';
import { Flex, Text } from '@chakra-ui/react';

import RinggoldBadge from './RinggoldBadge';
import { Avatar, Link } from '@morressier/alembic';
import { IReviewer } from '@publishing-engine/domain/models';
import { getOrcidUrl } from '../utils/utils';

interface ReviewerProps {
  reviewer: IReviewer;
  showAvatar?: boolean;
}

const AuthorHero: React.FC<ReviewerProps> = ({
  reviewer,
  showAvatar = true
}) => {
  const orcidUrl = getOrcidUrl(reviewer.orcid);

  return (
    <Flex
      padding={showAvatar ? 4 : 0}
      gap={4}
      bgColor="surfacePrimaryFill"
      alignItems="center"
    >
      {showAvatar && (
        <Avatar type="user" shape="round" width={20} height={20} />
      )}

      <Flex gap={1} flexDirection="column">
        <Text textStyle="headingItem">
          {reviewer.firstName} {reviewer.lastName}
        </Text>
        <Flex gap={1} alignItems="center">
          <Text noOfLines={1} overflow="hidden" textOverflow="ellipsis">
            {reviewer.affiliationDetails?.organizationName}
          </Text>
          {reviewer.affiliationDetails?.ringgoldId && <RinggoldBadge />}
        </Flex>
        <Link
          variant="primary"
          href={`mailto:${reviewer.email}`}
          isExternal
          textStyle="textBody"
        >
          {reviewer.email}
        </Link>
        {!!orcidUrl && (
          <Flex flexDirection="row" justifyContent="space-between">
            <Link variant="primary" href={orcidUrl}>
              {orcidUrl}
            </Link>
          </Flex>
        )}
      </Flex>
    </Flex>
  );
};

export default AuthorHero;
